import Store from "./store";
import { AppInfo, AppSnapshot, Snapshots } from '../model/models';
import Client from '../util/client';
import isEmpty from 'underscore-es/isEmpty';
import decode from '../util/htmldecode';


export interface State {
	app: AppInfo,
	snapshots: Snapshots<AppSnapshot>
}
const storeOpts: any = {
	state: (<any>window).__INITIAL_STATE__ || {
		app: null,
		snapshots: {}
	},
	getters: {
		notInitialized(state): boolean {
			return state.app == null;
		}
	},
	mutations: {
		setApp(state, app: AppInfo) {
			app.name = decode(app.name);
			state.app = app;
		},
		setSnapshots(state, snapshots: Snapshots<AppSnapshot>) {
			state.snapshots = snapshots;
		},
		normalize(state) {
			state.app.name = decode(state.app.name);
			var result: Snapshots<AppSnapshot> = {};
			var times = Object.keys(state.snapshots).map((val, i, a) => parseInt(val));
			times.forEach((i, index, a) => {
				var val: AppSnapshot = state.snapshots[i + ""];
				var notEmpty = false;
				for (let key in val) {
					if (val[key] !== 0) {
						notEmpty = true; break;
					}
				}
				if (notEmpty) { result[i] = val; }
			});
			state.snapshots = result;
		}
	},
	actions: {
		async loadAppInfo({ commit }, { id }) {
			const { data } = await Client.get(
				'/api/app/' + id
			);
			commit('setApp', data);
		},
		async loadSnapshots({ commit }, { id, from, to }) {
			const { data } = await Client.get(
				'/api/appstats/' + id + '/?from=' + from + '&to=' + to
			);
			commit('setSnapshots', data);
		}
	}
}

export const store = new Store(storeOpts);
export default store;